<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col
        align="center"
        justify="center">
          <v-img
            width="160px"
            src="https://pjili-public.s3.ca-central-1.amazonaws.com/global/images/pjili-logo-sm.png"
          ></v-img>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center">
      <v-col>

        <h1 class="text-center mb-5">Welcome to Pjili!</h1>

        <v-card
          class="mx-auto"
          max-width="400"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content class="text-center">
              <v-list-item-title class="headline">Please verify your phone</v-list-item-title>
              <v-list-item-subtitle class="pt-5">Pjili wants to make sure it’s really you.</v-list-item-subtitle>
              <v-list-item-subtitle>We will send a text message to this number with a 6-digit verification code.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-alert
              v-if="hasErrors()"
              color="warning">
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
            </v-alert>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-select
                      item-text="country"
                      item-value="code"
                      v-model="selectedCountry"
                      :items="countries"
                      :reduce="selectedCountry => selectedCountry.code"
                      label="Country/region"
                      required
                      return-object
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model.trim="phone"
                      :rules="phoneRules"
                      v-on:keydown.enter.prevent="submit"
                      name="Phone"
                      label="Phone, for example: 6471234567"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn
              to="/"
              rounded
              outlined
              color="grey">
              Sign in instead
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="submit()"
              rounded
              :loading="loading"
              :disabled="!valid"
              color="info"
            >
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SignupStart",
  data() {
    return {
      loading: false,
      valid: true,
      phoneRules: [],
      signUpIntent: {
        Id: '',
        Phone: ''
      },
      phone: '',
      selectedCountry: {
        country: "Canada +1",
        code: "1"
      },
      countries: [
        {
          country: "Canada +1",
          code: "1"
        },
        {
          country: "Israel +972",
          code: "972"
        },
        {
          country: "Luxembourg +352",
          code: "352"
        }
      ],
      errors: []
    };
  },
  watch: {
    selectedCountry: function () {
      this.phoneRules = []
    },
    phone: 'validateForm',
  },
  methods: {
    validateForm(){
      this.phoneRules = [
        v => !!v || 'Phone is required',
        v => (v && !isNaN(v))|| 'Must contain only numbers'
      ]

      if (this.selectedCountry.code == 1){
        this.phoneRules.push(v => (v && v.length == 10) || 'Phone number should be 10 digits')
      }

      this.$refs.form.validate()
    },
    submit(){
      this.loading = true
      // strip any non numeric charecters
      this.signUpIntent.Phone = this.selectedCountry.code + this.phone.replace(/[^0-9]/g, '')

      this.$axios.get('/signup/intent')
        .then((response) => {
          this.signUpIntent.Id = response.data
          this.$store.dispatch('SetSignUpIntent', this.signUpIntent)
          return this.$axios.post('/signup/otp', { Intent: this.signUpIntent.Id, Phone: this.signUpIntent.Phone })
        })
        .then(() => {
          this.$router.push({ name: 'signup-verify' })
          this.loading = false
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.errors = error.response.data.errors
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.errors = ["Network error"]
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errors = ["We're really sorry our systems seems to be unhealty now. Please try again later or contact us."]
          }
          this.loading = false
        })
    },
    hasErrors() {
      return this.errors.length > 0
    }
  }
}
</script>